export const UNAUTHORIZED_NOTIFICATION = 'unauthorizednotification';
